export default {
    "msg": {
        "8": "8",
        "20": "20",
        "250": "250",
        "Enter a new password": "请输入新密码",
        "which consists of uppercase letters, lowercase letters, numbers, and special characters, and includes at least 3 types": "密码由大写字母，小写字母，数字，特殊字符组成，且至少包3种",
        "Please enter the Confirmation Password": "请输入确认新密码",
        "the password is consistent with the new password": "密码与新密码一致",
        "Empty": "空",
        "No data": "暂无数据",
        //"Installation Package List": "安装包列表",
        "Update Package": "更新包",

        "Settings - Profiles": "设置-配置文件",
        "User Management": "用户管理",
        "Operation Records": "操作记录",
        "Exit": "退出",
        "Total pages:": "共",
        "page": "页",
        "Go to": "前往",
        "Prev": "上一页",
        "Next": "下一页",
        "per page": "每页",
        "items": "条",
        "Please enter the page number to go to": "请输入前往页数",
        "Profile": "配置",
        "Language": "语言模式",
        "Profile Picture": "头像",
        "Please Enter your x": "请输入{param}",
        "Select the x": "请选择{param}",
        "Old Password": "原密码",
        "New Password": "新密码",
        "Confirm Password": "确认新密码",
        "The two passwords entered do not match": "输入的两次密码不一致",
        "Enter the new password again": "请再次输入新密码",
        "This must match the new password above": "两次输入密码一致",
        "Invalid input。Password length must be 8–16 characters": "请求参数不正确:密码长度为 8-16 位",
        "Lenovo Privacy Statement": "联想隐私声明",
        "Lenovo Software License Agreement": "联想软件许可协议",
        "Third-Party Notice": "第三方通知",
        "Change Password": "修改密码",
        "Edit Profile": "修改个人信息",
        "Exited successfully": "成功退出",
        "Admin": "管理员",
        "Common user": "普通用户",
        "Model": "机型",
        "Are you sure you want to delete this?": "确认删除此信息吗？",
        "Enter a new password。It must include at least three of the following：uppercase letters，lowercase letters，numbers，and special characters": "请输入新密码，该密码必须至少包含以下四类中的三类：大写字母、小写字母、数字和特殊字符",
        "It must include at least three of the following: uppercase letters, lowercase letters, numbers, and special characters": "该密码必须至少包含以下四类中的三类：大写字母、小写字母、数字和特殊字符",
        "Tip": "提示",
        "Confirm": "确定",
        "Cancel": "取消",
        "Deletion successful": "删除成功",
        "Password changed successfully": "修改成功",
        "Please select the correct file type x": "请选择正确的文件类型{param}",
        "The file to upload is larger than 100 MB。 Please select another one。": "上传文件大于100MB，请重新选择",
        "Your session has expired。 Please log in again。": "当前登录状态已过期，请重新登录",
        "Invalid network request URL": "网络请求地址不正确",
        "Unknown server error": "服务器发生未知错误",
        "An unknown error has occurred": "发生未知错误!",
        "Request timeout。 Please check your network and try again。": "请求服务超时,可能没有网络，请重新操作",
        "Invalid request header!": "非法请求头！",
        "Illegal request header!": "非法请求头！",
        "Failed to connect to server": "未能连接至服务器",
        "Your network may be currently disconnected": "当前可能处于网络未连接状态",
        "No related device found": "没有找到相关设备",
        "Pre-upgrade component not found in the device": "设备中预升级组件未找到",
        "FWID of the installation component not found": "安装组件FWID未找到",
        "Failed to set upgrade information": "升级信息设置失败",
        "Failed to set specified update options": "指定更新设置失败",
        "Failed to install the update package": "更新包安装失败",
        "Failed to obtain the device handle": "设备句柄获取失败",
        "Upgrade device mismatch": "升级设备不匹配",
        "Installation failed: Pre-upgrade component not found in the device": "无法安装:设备中没有找到预升级组件",
        "Installation failed: FWID mismatch in the component list": "无法安装:组件中FWID不匹配",
        "Installation failed: No matching monitor found for upgrade": "无法安装:未找到升级匹配的显示器",
        "The monitor does not exist": "显示器不存在",
        "The command has been sent": "命令已经下发",
        "The group does not exist": "组不存在",
        "The command does not exist": "命令不存在",
        "Setting does not exist": "设置不存在",
        "The settings profile does not exist": "设置详情不存在",
        "The update package does not exist": "升级包不存在",
        "The update package record does not exist": "升级包记录不存在",
        "Invalid password format。 It must be between 8 and 30 characters long。": "密码格式不正确，密码长度必须在8到30个字符之间",
        "Password format is incorrect， password must include at least three types of the following: uppercase letters， lowercase letters， digits， and special characters": "密码格式不正确，密码至少包含大写字母、小写字母、数字和特殊字符中的三种类型",
        "The field is empty": "参数为空",
        "Update time cannot be null": "升级时间不能为空",
        "Invalid update time。 It cannot be earlier than the current time or more than 30 days in the future。": "更新时间无效。它不能早于当前时间，也不能超出未来 30 天的范围。",
        "Uploaded file is null": "上传文件为空",
        "Uploaded file format is incorrect， file format can only be zip/exe/dmg/app": "上传文件格式不正确,文件格式只能为zip/exe/dmg/app",
        "Uploaded file format is incorrect， file cannot have no extension": "上传文件格式不正确,文件不能没有后缀",
        "The file is too large and can not exceed": "文件太大，不能超过",
        "The file is too large and can not exceed 500MB": "文件太大，不能超过500MB",
        "The file is too large and can not exceed 400MB": "文件太大，不能超过400MB",
        "The file is too large and can not exceed 300MB": "文件太大，不能超过300MB",
        "The file is too large and can not exceed 200MB": "文件太大，不能超过200MB",
        "The file is too large and can not exceed 100MB": "文件太大，不能超过100MB",
        "Login failed。 Make sure you entered the correct account ID and password。": "登录失败，账号密码不正确",
        "Date": "日期",
        "Time": "时间",
        "Please select an item to delete first": "请先选中一项再删除",
        "Select an item and then delete": "请先选中一项再删除",
        "Begin Download": "开始下载",
        "Start Download":"开始下载",
        "Password incorrect": "密码错误",
        "Password Changed Successfully": "修改密码成功",
        "Display ID or Group ID is empty": "显示器id或组id为空",
        "Select the update package": "请选择更新包",
        "Username already exists": "用户名已存在",
        "Executing monitor setting command。Please wait 10s before making new changes。": "该显示器设置命令正在执行中，请等待10s后，再进行新的设置。",
        "Role does not exist。 Cannot modify role。": "角色不存在，无法修改角色",
        "Unknown Command": "未知命令",
        "Access Token Expired": "访问令牌已过期",
        "Invalid Refresh Token": "无效的刷新令牌",
        "Missing Request Parameters:": "请求参数缺失:",
        "Incorrect Request Parameter Type:": "请求参数类型错误:",
        "Request URL Not Found:": "请求地址不存在:",
        "Incorrect Request Method:": "请求方法不正确:",
        "Log In": "登录",
        "account ID": "账号",
        "password": "密码",
        "Update failed": "升级失败",
        "Reset Password?": "重置密码",
        "Input characters within x characters": "输入字符在{param}个字符以内",
        "Logged in successfully": "登录成功",
        "Please contact the system administrator to reset your password": "请联系管理员，进行密码重置",
        "Retry limit exceeded。 Please try again after 30 minutes": "重试超过5次，请30分钟后再试",
        "Enter the model / host name / firmware version number": "请输入型号/主机名/固件版本号",
        "New Group": "创建组",
        "Delete Group": "删除组",
        "Display Columns": "显示列",
        "Collapse": "折叠",
        "Expand": "展开",
        "Move To": "移动到",
        "Export": "导出",
        "Power On": "开启电源",
        "Power Off": "关闭电源",
        "Screen lock": "屏幕锁定",
        "Unlock screen": "屏幕解锁",
        "Settings": "设置",
        "Export Settings Profiles": "导出设置配置文件",
        "Settings Profiles": "设置配置文件",
        "Update": "升级",
        "Delete Monitor": "删除显示器",
        "Total devices": "设备总数量",
        "Selected devices": "设备选中量",
        "Update package name": "更新包名",
        "Update Time": "更新时间",
        "Apply to all displays of the same model": "应用于同型号显示器",
        "Display Settings": "显示设置",
        "Select All": "全选",
        "Filename": "文件名",
        "Group": "组",
        "Monitor Model": "显示器型号",
        "Special ID": "特殊ID",
        "Host Name": "主机名称",
        "Host Status": "主机状态",
        "Monitor Status": "显示器状态",
        "Lock Status": "锁定状态",
        "Update Progress": "升级进度",
        "Settings Profile": "创建设置",
        "Tips": "提示信息",
        "Active Time": "使用时长",
        "Overclock": "超频",
        "Operation successful": "操作成功",
        "Please save data": "请先保存数据",
        "Select the data first": "请先选择显示器",
        "Cannot modify when ungrouped": "未分组无法修改",
        "Deselect All": "取消全选",
        "Select the GAMMA node label value": "请选中GAMMA节点标签的值",
        "Ungrouped": "未分组",
        "Offline": "离线",
        "Online": "在线",
        "Power on": "开机",
        "Power off": "关机",
        "Locked": "锁定",
        "Open": "未锁定",
        "Open": "未锁定",
        "Unlocked":"未锁定",
        "Not connected": "未连接",
        "Connected": "连接",
        "Set the update start time": "设定升级的开始时间",
        "Now": "现在",
        "Set upgrade mode": "设置升级模式",
        "Interactive Mode": "交互模式",
        "Silent mode": "静默模式",
        "In this mode， a monitor firmware update screen appears and requests confirmation to proceed。Users may choose to postpone the update twice，after which the update is mandatory。": "在这种模式下，用户将会看到显示器固件更新界面，需要用户确认，更新才会进行。用户有两次选择稍后升级的机会，两次延迟过后，将强制执行更新。",
        "In this mode， when the monitor is online， the firmware update will be automatically performed in the background。 Users will not see any notifications。 The update will take effect when the display is restarted。 The restart of the monitor takes about a few seconds， and won’t affect any ongoing tasks on your computer。": "在这种模式下，当显示器在线时，新的固件会以后台的方式立即更新到显示器，用户看不到任何界面，但是新的固件直到显示器重启后才会生效。显示器重启大概需要几秒钟的时间，它不会影响用户电脑上当前进行的任务。",
        "Invalid input": "请求参数不正确",
        "Failed to log in": "账号未登录",
        "Select your preferred restart time。": "请根据您的企业使用显示器的实际情况，选择您期望的显示器重启时机。",
        "You have still selected the group that the device currently belongs to。 If you want to move the device， please select another group。": "您点击的仍是设备现属组，若要移动，请选其他组。",
        "Enter the group name": "请输入组名称",
        "Apply profile:": "应用设置配置文件：",
        "A new version is available": "有新版本，可以去升级",
        "Restart monitor immediately after update": "更新完立即重启",
        "Restart when the monitor enters sleep mode": "显示器进入休眠状态时重启",
        "Restart monitor when it disconnected from all PCs": "当显示器断开和所有的PC连接时重启",
        "Enter the model name": "请输入机型名称",
        "Create Update Task": "创建升级任务",
        "Update Task List": "升级任务列表",
        "Cancel All": "取消全部",
        "View Details": "查看详情",
        "Update Details": "升级详情",
        "Update Mode": "升级模式",
        "Update Creation Time": "升级的创建时间",
        "Update Start Time": "升级的开始时间",
        "Are you sure you want to cancel all tasks?": "确认取消全部任务么？",
        "Are you sure you want to cancel this task?": "确认取消此任务么？",
        "Are you sure you want to delete the selected monitor?": "确认要删除选中的显示器吗？",
        "Confirm to delete all displays?": "确认要删除所有显示器吗？",
        "You have not selected the monitor to delete。 Please check the monitor in the table!": "您没有选择要删除的显示器，请勾线表格中的显示器！",
        "Are you sure you want to delete this？（Cannot delete when ungrouped）": "确认删除此信息吗？（未分组无法删除）",
        "Tip: If an option in the display settings appears grayed out， it may be restricted by another setting。 Try adjusting other settings to remove the restriction。": "提示：显示器设置中若某选项变灰，有可能该选项是被其它选项的设置所制约，可以尝试改变其他设置以取消制约。",
        "The WebSocket connection has been lost Reconnecting": "WebSocket链接已断开，重连中",
        "The WebSocket connection has been restored": "WebSocket链接已重连成功！",
        "The previous setting is currently being applied。 Please wait until the value changes before making any new settings。": "上一设置正在执行中，请等待数值变化后，再进行新的设置",
        "Please copy this password into the input box: ": "请复制该密码到输入框: ",
        "Ebook": "电子书",
        "largest": "最大",
        "Max":"最大",
        "Turn off auto mode": "关闭自动模式",
        "Minimum": "minimum",
        "Restore Factory Settings": "恢复出厂设置",
        "Scenario Mode": "情景模式",
        "Color Gamut & Color Temperature": "色温色域",
        "Color adjustment-red": "颜色调整-红",
        "Color adjustment-green": "颜色调整-绿",
        "Color adjustment-blue": "颜色调整-蓝",
        "Close PIP, PBP":"关闭",
        "Close":"关闭",
        "PIP window":"PIP",
        "PBP window":"PBP",
        "Panel Native": "初始设置",
        "Neutral": "标准色温",
        "Reddish":"暖色温",
        "Neutral(7500K)":"标准色温",
        "Reddish(6500K)":"暖色温",
        "Bluish(9300K)":"冷色温",
        "Bluish":"冷色温",
        "Warm": "Reddish",
        "Cool": "带蓝色的",
        "Low Blue Light": "低蓝光",
        "Custom 1": "定制1",
        "Custom 2": "定制2",
        "Custom 3": "定制3",
        "BT.709": "BT.709",
        "BT.2020": "BT.2020",
        "Video Signal": "输入信号",
        "Game Mode": "游戏模式",
        "Off": "关闭",
        "Game 1": "游戏 1",
        "Game 2": "游戏 2",
        "Response Time": "响应时间",
        "Normal": "正常",
        "Extreme": "极限",
        "Level 1": "级别 1",
        "Level 2": "级别 2",
        "Level 3": "级别 3",
        "Level 4": "级别 4",
        "Level 5": "级别 5",
        "Lan Indicator": "LAN指示灯",
        "Linked": "linked",
        "No Link": "nolink",
        "Blinking": "blinking",
        "Brightness": "亮度",
        "Contrast": "对比度",
        "Smart Light": "智能感光",
        "Volume Control": "音量调节",
        "USB Select": "USB模式",
        "DP Select": "DP模式",
        "Aspect Ratio": "显示比例",
        "Smart Traffic Light": "智能交通灯",
        "daisy chain": "菊花链",
        "Dynamic Contrast": "动态对比度",
        "Smart Energy": "智能能源",
        "Smart Audio": "智能音频",
        "Distance Warning": "距离检测",
        "Ambient Light Detection": "环境光检测",
        "Enabled Ambient Light Detection": "开启环境光检测",
        "enabled":"启用",
        "disabled":"禁用",
        "Waken on Touch": "触摸唤醒",
        "True Split": "硬分屏",
        "Face Tracking": "人脸追踪",
        "Audio Smart Switch": "音频智能开关",
        "Auto-alarm": "自动警示",
        "KVM Switch": "KVM切换",
        "KVM切换": "KVM切换",
        "KVM(Keyboard, Video, Mouse)": "KVM（键盘、显示器、鼠标）切换功能可以使用两台电脑使用一条显示器、键盘和鼠标，打开同时切换显示器、键盘鼠标功能，如果关闭此功能，则仅切换键盘和鼠标",
        // "KVM(Keyboard, Video, Mouse) Switch enables two PCs to use one set of monitor, keyboard and mouse, Enable switching video, keyboard and mouse simultaneously. If disabled, only switch keyboard and mouse.": "KVM（键盘、显示器、鼠标）切换功能可以使用两台电脑使用一条显示器、键盘和鼠标，打开同时切换显示器、键盘鼠标功能，如果关闭此功能，则仅切换键盘和鼠标",
        "Sitting Reminder": "久坐提醒",
        "Gaming": "游戏",
        "RGB Gain": "颜色调整",
        "Serial No": "序列号",
        "Firmware Version": "固件版本号",
        "Select response time level": "选择响应时间等级",
        "Enable daisy chain": "启用菊花链",
        "Smart Traffic Light is a do not disturb light, helping to reduce distraction": "智能交通灯是一个请勿打扰灯，帮助降低干扰",
        "Enable/Disable the Audio Smart function": "启用/禁用音频智能开关",
        "Auto-alarm indicates whether the camera/MIC on monitor is in use": "自动警示功能指示显示器上的摄像头/麦克风是否正在被使用",
        "Enable Distance Warning": "开启距离检测",
        "Enable/disable face tracking": "打开或关闭人脸追踪功能",
        "Enable Sitting Reminder": "开启久坐提醒",
        "Smart Audio technology allows you to focus on the sound in front of you to improve voice clarity": "智能音频技术帮助你专注显示器正前方的声音，减少环境噪音，提高声音清晰度",
        "Smart Energy technology automatically manages energy consumption by human detection sensor": "智能能源技术通过人体传感器来帮助你自动管理显示器能源消耗",
        "Implement PBP through only one cable": "硬分屏帮助你用一根线实现PBP功能",
        "Enable/Disable vPro technology in the monitor": "启用/禁用vPro功能",
        "Wake system by touch": "通过触摸屏幕唤醒系统",
        "Set video source and USB source (used by keyboard and mouse) for every PC": "为每台PC设置输入信号源和USB源",
        "eKVM gives you instant access over two PC sources with a 2-button pressing of your mouse": "eKVM让您只需要同时按下鼠标的左右键，即可切换USB信号源",
        "Enable USB charging always on": "始终允许USB充电",
        "Select DP version": "选择DP版本",
        "USB Charging": "usb充电",
        "PC": "电脑",
        "Double-click the CTRL": "双击CTRL键",
        "Full Screen": "全屏",
        "Original AR": "原始比例",
        "No scaling": "无缩放",
        "On": "开启",
        "on": "开启",
        "Keyboard On": "键盘开启",
        "Mouse On": "鼠标开启",
        "Image Creation": "图像创建",
        "Digital Cinema": "数字电影",
        "Video Creation": "视频创建",
        "Web Browsing": "网页浏览",
        "Professional Image": "专业形象",
        "DisplayPort": "显示端口",
        "Auto": "自动",
        "auto": "自动",
        "Refresh": "刷新",
        "Search": "搜索",
        "Record": "记录",
        "Username": "用户名",
        "Upload Time": "上传时间",
        "Add Profiles": "增加配置",
        "Latest Update Package": "最新更新包",
        "Upload Update Package": "上传更新包",
        "Upload": "上传",
        "Size": "大小",
        "Upload successful": "上传成功",
        "The file name contains illegal characters": "文件名包含非法字符",
        "Download successful": "下载成功",
        "Refresh successful": "刷新成功",
        "The upgrade package does not match the device model": "升级包与机型不匹配",
        "Upgrade package does not match the device model":"升级包与机型不匹配",
        "Please enter the setting name": "请输入设置名称",
        "Edit": "编辑",
        "Save": "保存",
        "Delete": "删除",
        "Add": "添加",
        "Reset Password": "密码重置",
        "No": "序号",
        "Full Name": "全名",
        "Role": "角色",
        "Creation Date": "创建日期",
        "Operation": "操作内容",
        "Actions": "操作",
        "The user's initial password is ": "该用户的初始密码为：",
        "The password has been reset to：": "密码已经重置为：",
        "Invalid input。Usernames can only contain numbers and letters。": "请求参数不正确:用户名由 数字、字母 组成",
        "Invalid input。The username must contain 4 to 30 characters。": "请求参数不正确:用户名长度为 4-30 个字符",
        "Installation Package": "安装包",
        "Operation Date": "操作日期",
        "Operator": "操作人",
        "Paging component": "分页组件",
        "Quick page flipping": "快速翻页",
        "Current page": "当前页",
        "Title": "标题",
        "Details": "详细信息",
        "This is the expanded area": "这是扩展区域",
        "Set Display Column": "设置显示列",
        "Upload file": "上传文件",
        "Drop-down to expand": "下拉展开",
        "Default": "default",
        "Default Info": "默认信息",
        "Personal Center": "个人中心",
        "Personal center image button": "个人中心图片按钮",
        "Expandable area": "可展开区域",
        "Update Package Table": "更新包表格",
        "This is the table header": "这是表格标头",
        "This is the table content": "这是表格内容",
        "UserList Table": "用户列表表格",
        "Page Up and Down": "上下翻页",
        "Operation record table": "操作记录表格",
        "OSD upgrade details": "OSD升级详情",
        "Lenovo": "Lenovo",
        "Display Fleet Manager": "Display Fleet Manager",
        "HDR": "HDR",
        "eKVM": "eKVM",
        "Video": "Video",
        "Data": "Data",
        "vPro": "vPro",
        "Gama": "Gamma",
        "PIP/PBP": "PiP/PbP",
        "OSD": "OSD",
        "USB-C Charging": "USB-C充电",
        "PIP": "PIP",
        "PBP": "PBP",
        
        "Simplified Chinese": "简体中文",
        "English": "English",
        "Traditional Chinese": "繁體中文",
        "French": "Français",
        "German": "Deutsch",
        "Italian": "Italiano",
        "Spanish": "Español",
        "Japanese": "日本語",
        "Thai": "ภาษาไทย",
        "Ukrainian": "Українська",
        "Russian": "Русский язык",

        "Enter your account ID": "请输入账号",
        "Please Enter your account id":"请联系管理员，进行密码重置",
        "Enter your password": "请输入密码",
        "Cannot exceed 20 characters": "输入字符在20个字符以内",
        "Enter the original password": "请输入原密码",
        "You have still selected the group that the device currently belongs to。 If you want to move the device, please select another group。": "您选择的仍是设备现属组，若要移动，请选其他组。",
        "Enter the filename": "请输入文件名",
        "Update Package Name": "更新包名称",
        "Select the date": "请选择日期",
        "Select the time": "请选择时间",
        "Set the update mode": "设定升级模式",
        "Restart when the monitor is not connected to any computer": "当显示器断开和所有PC连接时重启",
        "Invalid file format": "文件格式无效，仅支持 zip、exe、dmg、app 格式的文件。",
        "Select a valid file type": "请选择正确的文件类型",
        "The data will be permanently deleted": "此操作将永久删除当前数据，是否继续？",
        "The data is being processed。 Please do not submit again。": "数据正在处理，请勿重复提交。",
        "Enter the profiles name": "请输入配置文件名称",
        "Enter your username": "请输入用户名",
        "Enter your full name": "请输入全名",
        "The initial password of this user is:": "该用户的初始密码为：",
        "Select your role": "请选择角色",
        "User Profile": "用户设置",
        "Downloading": "正在下载...",
        "Enter the new password again。Two times of new password input is same": "请再次输入新密码，两次输入密码一致",
        "Request failed with status code 502": "请求失败，状态代码为502",
        "This is my first login":"这是第一次登录",

        "Monitor List":"显示器列表",
        "List of update packages":"更新包列表",
        "Settings - Profiles":"设置-配置文件",
        "User Management":"用户管理",
      
        
        "System abnormality":"系统异常",

        "Upgrade Package Record ID is empty":"升级包记录不存在",

        "Invalid update time。 It cannot be earlier than the current time or more than 30 days in the future。":"升级时间格式不正确，不能小于当前时间或超过当前时间30天。",
      
        "Request parameter is invalid:The username must contain 4 to 30 characters。":"请求参数不正确:用户名长度为 4-30 个字符",
        "Request parameter is invalid：Usernames can only contain numbers and letters。":"请求参数无效：用户名由数字和字母组成。",
 
        "Request parameter is invalid:Password length must be between 8-16 character":"请求参数无效：密码长度必须在8-16个字符之间",
        "The compiled package is missing: the component has a corresponding bin that has not been uploaded。Please upload it before compiling":"已编译的包丢失：该组件有一个尚未上传的相应bin请在编译前上传。",
        "Request parameter is invalid：Password length must be 8–16 characters":"请求参数无效：密码长度必须在8-16个字符之间",

        "Third-party notifications": "第三方通知",

        "Invalid request parameters":"错误的请求参数",
        "It is already a high-version and there is no need to upgrade":"它已经是高版本，无需升级",
        "Repeated request， please try again later":"Repeated request, please try again later",
        "Communication":"通信中"
    }
}